import { SyncLoader } from "./SyncLoader";
import { connect } from "react-redux";
import { translate } from "react-i18next";
const mapStateToProps = state => ({
  progress: state.loader.progress,
  text: state.loader.text,
  fetching: state.synchronization.fetching
});

export default connect(mapStateToProps)(translate("translations")(SyncLoader));



// WEBPACK FOOTER //
// ./src/synchronization/SyncLoader/index.js